<template>
  <div>
    <div class="page-wrapper">
      <div :class="isShow ? 'page-content-wrapper' : ''">
        <div class="shadow-btm">
          <div class="row">
            <div class="col-lg-5 col-sm-6 my-auto">
              <h4 class="mb-0 lg-bld">
                <a v-on:click="toggleMenu()" class="mr-3"
                  ><i class="bx bx-menu"></i
                ></a>
                <span>Member List</span>
              </h4>
            </div>
            <div class="col-lg-7 col-sm-6 text-last">
              <div class="mr-2">
                <a
                  style="font-size: 14px"
                  v-on:click="downloadBlankFormPdf()"
                  class="fill-btn btn-style cursor-pointer ml-3"
                  ><i class="fa fa-download"></i>&nbsp; Download Form</a
                >
              </div>

              <div class="mr-2">
                <a
                  style="font-size: 14px"
                  v-on:click="downloadPdf()"
                  class="fill-btn btn-style cursor-pointer"
                  ><i class="fa fa-download"></i>&nbsp; Download Excel</a
                >
              </div>
              <div v-if="accessObject?.is_add">
                <a
                  style="font-size: 14px"
                  v-on:click="$router.push('/add-user')"
                  class="fill-btn btn-style cursor-pointer"
                  >+ Add User</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-content px-3"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage">
          <div class="card-body py-0 px-0">
            <ul class="nav nav-pills col-12 row p-0 m-0">
              <li class="nav-item cursor-pointer mb-3 col-6 p-0 m-0">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  :class="{ active: currentTab == 'ACCEPTED' }"
                  v-on:click="changeTab('ACCEPTED')"
                  style="
                    text-align: center;
                    align-content: start;
                    font-size: 14px;
                  ">
                  <span>Member List ({{ count }})</span>
                </a>
              </li>
              <li class="nav-item cursor-pointer col-6 p-0 m-0" style="">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  style="
                    cursor: pointer;
                    font-size: 14px;
                    text-align: center;
                    align-content: end;
                    background-color: white;
                  "
                  v-on:click="$router.push('/married-list/HIDE')">
                  <span>Married List</span>
                </a>
              </li>
            </ul>

            <div class="mb-0 radius-15">
              <!-- card border -->

              <div>
                <div class="row ml-2 mb-3">
                  <div
                    class="row"
                    style="
                      justify-content: space-between;
                      display: flex;
                      align-items: initial;
                      width: 100%;
                      margin-top: 12px;
                      margin-bottom: -4px !important;
                    ">
                    <div class="has-search" style="width: 15%">
                      <!-- <span class="bx bx-search form-control-feedback"></span> -->
                      <i
                        class="fa fa-search"
                        style="position: absolute; margin: 10px"
                        aria-hidden="true"></i>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Search "
                        v-model="searchObj.keyword"
                        v-on:keyup.enter="getList(0)" />
                    </div>
                    <div class="form-group mt-2" style="">
                      <a
                        style="font-size: 14px"
                        class="fill-btn btn-style cursor-pointer mr-3"
                        v-on:click="getList(0)"
                        >Search</a
                      >
                      <a
                        style="font-size: 14px"
                        class="fill-btn btn-style cursor-pointer"
                        v-on:click="resetFilter()"
                        >Reset</a
                      >
                    </div>
                    <div class="form-group" style="width: 12%">
                      <div class="styled-select">
                        <select
                          v-on:change="getList(0)"
                          v-model="searchObj.gender"
                          name=""
                          aria-required="true"
                          aria-invalid="false">
                          <option value="" selected="selected">
                            Select Gender
                          </option>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                        </select>
                        <span
                          class="bx bx-chevron-down"
                          style="top: 6px; right: 8px"></span>
                      </div>
                    </div>
                    <div class="form-group" style="width: 12%">
                      <div class="styled-select">
                        <select
                          v-on:change="getList(0)"
                          v-model="searchObj.membership_plan_id"
                          name=""
                          aria-required="true"
                          aria-invalid="false">
                          <option value="" selected="selected">
                            Select Plan
                          </option>
                          <option value="FREE_MEMBER">Free Member</option>
                          <option
                            v-for="(data, index) in planList"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </select>
                        <span
                          class="bx bx-chevron-down"
                          style="top: 6px; right: 8px"></span>
                      </div>
                    </div>
                    <div class="form-group" style="width: 12%">
                      <div class="styled-select">
                        <select
                          v-on:change="getList(0)"
                          v-model="searchObj.is_hidden"
                          name="is_hidden"
                          aria-required="true"
                          aria-invalid="false">
                          <option value="" selected="selected">All</option>
                          <option value="H">Hidden</option>
                          <option value="B">Blocked</option>
                        </select>
                        <span
                          class="bx bx-chevron-down"
                          style="top: 6px; right: 8px"></span>
                      </div>
                    </div>
                    <div class="form-group" style="width: 12%">
                      <div class="styled-select">
                        <select
                          name="marital_status_id"
                          class="form-control"
                          style="cursor: pointer"
                          placeholder="Marrital Status"
                          v-model="searchObj.marital_status_id"
                          v-on:change="getList(0)"
                          aria-required="true"
                          aria-invalid="false">
                          <option value="" selected="selected">
                            Select Status
                          </option>

                          <option
                            v-for="(data, index) in marriedStatusList"
                            :key="index"
                            :value="data.uuid">
                            {{ data.name }}
                          </option>
                        </select>
                        <span
                          class="bx bx-chevron-down"
                          style="top: 6px; right: 8px"></span>
                        <!-- <a
                          class="fill-btn cursor-pointer btn-style ml-2"
                          v-show="searchObj.marital_status_id"
                          v-on:click="resetStatusFilter()"
                          >Reset</a
                        > -->
                      </div>
                    </div>
                    <div class="form-group" style="width: 12%">
                      <label
                        style="
                          font-size: 12px;
                          position: relative;
                          right: 0.3rem;
                          top: 0.2;
                          margin-top: 7px;
                        "
                        >Incomplete Profiles</label
                      >
                      <span></span>
                      <input
                        id="is_incomplete"
                        type="checkbox"
                        v-model="searchObj.is_incomplete"
                        true-value="1"
                        false-value="0"
                        @change="getList(0)" />
                    </div>
                    <div class="form-group" style="display: none">
                      <a
                        style="font-size: 14px"
                        class="fill-btn btn-style cursor-pointer mr-3"
                        v-on:click="getList(0)"
                        >Search</a
                      >
                      <a
                        style="font-size: 14px"
                        class="fill-btn btn-style cursor-pointer"
                        v-on:click="resetFilter()"
                        >Reset</a
                      >
                    </div>
                    <!-- <div class="form-group" style="">
                      
                    </div> -->
                  </div>
                </div>

                <div class="card mb-0 radius-15 custom-table">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <div class="row" style="word-spacing: -3px">
                          <span class="ml-4" style="color: black"
                            >Action -
                          </span>
                          <span
                            class="ml-4"
                            style="color: black"
                            v-if="accessObject?.is_hide"
                            >H - Hide
                          </span>
                          <span
                            class="ml-4"
                            style="color: black"
                            v-if="accessObject?.is_block"
                            >B - Block</span
                          >
                          <span
                            class="ml-4"
                            style="color: black"
                            v-if="accessObject?.is_delete"
                            >D - Delete</span
                          >
                          <span
                            class="ml-4"
                            style="color: black"
                            v-if="accessObject?.is_edit"
                            >E - Edit</span
                          >
                          <span class="ml-4" style="color: black"
                            >P - Print
                          </span>
                          <span class="ml-4" style="color: black">
                            A - Activity
                          </span>
                          <!-- <span class="ml-4" style="color: black">
                            F - Find Match</span
                          > -->
                          <span
                            class="ml-4"
                            style="color: black"
                            v-if="accessObject?.is_sl">
                            SL - Short List</span
                          >
                          <span
                            class="ml-4"
                            style="color: black"
                            v-if="accessObject?.is_bl">
                            BL - Broad List</span
                          >
                          <span class="ml-4">
                            <a
                              style="background-color: #f9dca6"
                              class="fill-btn2"></a>
                            <span>&nbsp; - Has Profile Photo</span>
                          </span>
                          <span class="ml-4">
                            <a
                              style="background-color: rgb(210, 242, 210)"
                              class="fill-btn2"></a>
                            <span>&nbsp; - No Subscription</span>
                          </span>
                          <span class="ml-4">
                            <a
                              style="background-color: rgb(237, 234, 234)"
                              class="fill-btn2"></a>
                            <span>&nbsp; - Hidden</span>
                          </span>
                          <span class="ml-4">
                            <a
                              style="background-color: rgb(254, 254, 204)"
                              class="fill-btn2"></a>
                            <span>&nbsp; - Blocked</span>
                          </span>
                        </div>
                        <div class="tableFixHead">
                          <table
                            class="table table-striped table-bordered"
                            role="grid"
                            aria-describedby="example_info"
                            id="members-list">
                            <thead>
                              <tr role="row">
                                <th class="actwid">Actions</th>
                                <th
                                  class="sorting cvwidth"
                                  id="id-contacts_viewed"
                                  v-on:click="
                                    sorting(
                                      'contacts_viewed',
                                      'id-contacts_viewed',
                                    )
                                  ">
                                  <div>CV</div>
                                </th>
                                <th
                                  style=""
                                  class="sorting"
                                  id="id-echo_status"
                                  v-on:click="
                                    sorting('echo_status', 'id-echo_status')
                                  ">
                                  <div>ES</div>
                                </th>
                                <th
                                  style=""
                                  class="sorting"
                                  id="id-personality"
                                  v-on:click="
                                    sorting('master.name', 'id-personality')
                                  ">
                                  <div>P</div>
                                </th>
                                <th
                                  style=""
                                  class="sorting"
                                  id="id-fee"
                                  v-on:click="sorting('t.amount', 'id-fee')">
                                  <div>Rs</div>
                                </th>
                                <th
                                  style=""
                                  class="sorting widID"
                                  id="id-registration_no"
                                  v-on:click="
                                    sorting(
                                      'registration_no',
                                      'id-registration_no',
                                    )
                                  ">
                                  <div>ID</div>
                                </th>
                                <!-- <th>Photo</th> -->
                                <th
                                  class="sorting surwid"
                                  id="id-first_name"
                                  v-on:click="
                                    sorting('first_name', 'id-first_name')
                                  ">
                                  <div>F Name</div>
                                </th>
                                <th
                                  class="sorting surwid"
                                  id="id-middle_name"
                                  v-on:click="
                                    sorting('middle_name', 'id-middle_name')
                                  ">
                                  <div>M Name</div>
                                </th>
                                <th
                                  class="sorting surwid"
                                  id="id-last_name"
                                  v-on:click="
                                    sorting('last_name', 'id-last_name')
                                  ">
                                  <div>Surname</div>
                                </th>
                                <th
                                  class="sorting nativewidth"
                                  id="id-native_place_taluka"
                                  v-on:click="
                                    sorting(
                                      'native_district.name',
                                      'id-native_place_taluka',
                                    )
                                  ">
                                  <div>Native<br />Dist + Tal</div>
                                </th>
                                <th
                                  style="width: 150px"
                                  class="sorting"
                                  id="id-taluka"
                                  v-on:click="
                                    sorting(
                                      'family_residence.name',
                                      'id-taluka',
                                    )
                                  ">
                                  <div>Family Res.<br />Tal + A/G</div>
                                </th>
                                <th
                                  style="width: 120px"
                                  class="sorting"
                                  id="id-working_place_taluka"
                                  v-on:click="
                                    sorting(
                                      'working.name',
                                      'id-working_place_taluka',
                                    )
                                  ">
                                  <div>Work Location</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-annual_income"
                                  v-on:click="
                                    sorting('annual_income', 'id-annual_income')
                                  ">
                                  <div>Inc.</div>
                                  <div>(Lac)</div>
                                </th>
                                <th
                                  style="width: 250px"
                                  class="sorting eudwid"
                                  id="id-education_courses"
                                  v-on:click="
                                    sorting(
                                      'education_courses',
                                      'id-education_courses',
                                    )
                                  ">
                                  <div>Education</div>
                                </th>
                                <th
                                  class="sorting dobwid"
                                  id="id-dob"
                                  v-on:click="sorting('dob', 'id-dob')">
                                  DOB
                                </th>
                                <th
                                  class="sorting HTwid"
                                  id="id-height"
                                  v-on:click="sorting('height', 'id-height')">
                                  <div>HT.</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody v-show="!loader">
                              <tr v-for="(data, index) in list" :key="index">
                                <td
                                  :id="'member_' + data.id"
                                  style=""
                                  class=""
                                  :style="
                                    data.image
                                      ? 'background-color:#F9DCA6'
                                      : white
                                  ">
                                  <a
                                    v-if="accessObject?.is_hide"
                                    class="cursor-pointer"
                                    style="color: black; font-size: 10px"
                                    :style="
                                      data.is_hidden == 'Y'
                                        ? 'color: grey '
                                        : 'color: black'
                                    "
                                    title="Hide"
                                    v-on:click="showHidePopup(data)">
                                    H</a
                                  >&nbsp;&nbsp;
                                  <a
                                    v-if="accessObject?.is_block"
                                    class="cursor-pointer"
                                    style="color: black; font-size: 10px"
                                    :style="
                                      data.block == 'Y'
                                        ? 'color: grey '
                                        : 'color: black'
                                    "
                                    title="Block"
                                    v-on:click="showBlockPopup(data)"
                                    >B</a
                                  >&nbsp;&nbsp;
                                  <a
                                    v-if="accessObject?.is_delete"
                                    class="cursor-pointer"
                                    title="Delete"
                                    style="color: black; font-size: 10px"
                                    v-on:click="showDeletePopup(data)"
                                    >D</a
                                  >&nbsp;&nbsp;
                                  <a
                                    v-if="accessObject?.is_edit"
                                    title="Edit"
                                    style="
                                      cursor: pointer;
                                      color: black;
                                      font-size: 10px;
                                    "
                                    v-on:click="
                                      goToUrl(
                                        data.id,
                                        '/edit-user/' + data.uuid,
                                      )
                                    "
                                    >E</a
                                  >&nbsp;&nbsp;
                                  <div>
                                    <a
                                      class="cursor-pointer"
                                      v-on:click="downloadProfile(data)"
                                      style="color: black; font-size: 10px"
                                      title="Print"
                                      >P</a
                                    >&nbsp;&nbsp;
                                    <a
                                      class="cursor-pointer"
                                      style="color: black; font-size: 10px"
                                      title="Activity"
                                      v-on:click="
                                        goToUrl(
                                          data.id,
                                          '/user-activity/' + data.uuid,
                                        )
                                      "
                                      >A</a
                                    >&nbsp;&nbsp;

                                    <a
                                      v-if="accessObject?.is_sl"
                                      class="cursor-pointer"
                                      style="color: black; font-size: 10px"
                                      title="Short List"
                                      v-on:click="
                                        goToUrl(
                                          data.id,
                                          '/short-list/' +
                                            data.uuid +
                                            '/' +
                                            'SHORT',
                                        )
                                      "
                                      >SL</a
                                    >&nbsp;&nbsp;

                                    <a
                                      v-if="accessObject?.is_bl"
                                      class="cursor-pointer"
                                      style="color: black; font-size: 10px"
                                      title="Broad List"
                                      v-on:click="
                                        goToUrl(
                                          data.id,
                                          '/broad-list/' +
                                            data.uuid +
                                            '/' +
                                            'BROAD',
                                        )
                                      "
                                      >BL</a
                                    >
                                  </div>
                                </td>
                                <td>
                                  <span
                                    style="
                                      text-align: center;
                                      color: #bd1c9c;
                                      display: grid;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.contacts_viewed }}</span
                                  >
                                </td>
                                <td style="">
                                  <span
                                    style="
                                      text-align: center;
                                      display: grid;
                                      color: #bd1c9c;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.echo_status_name
                                        ? data.echo_status_name
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    style="color: #bd1c9c"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.personality_name
                                        ? data.personality_name
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td style="" class="">
                                  <span
                                    style="color: #bd1c9c"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.amount
                                        ? $helperService.kThousandFormatter(
                                            data.amount,
                                          )
                                        : "0k"
                                    }}</span
                                  >
                                </td>
                                <!-- :style="
                                    data.block == 'Y'
                                      ? 'background-color:rgb(254, 254, 204)'
                                      : data.is_hidden == 'Y'
                                      ? 'background-color:rgb(237, 234, 234)'
                                      : ''
                                  " -->
                                <td
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  "
                                  style="color: #bd1c9c; cursor: pointer"
                                  class="">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.registration_no
                                        ? data.registration_no
                                        : "-"
                                    }}</span
                                  >
                                  <!-- <hr> -->
                                  <!-- <span
                                    style="font-size: 12px"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    OLD :
                                    {{
                                      data.old_registration_no
                                        ? data.old_registration_no
                                        : "-"
                                    }}
                                  </span> -->
                                </td>

                                <td
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  "
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.is_hidden == 'Y'
                                      ? 'background-color:rgb(237, 234, 234)'
                                      : ''
                                  ">
                                  <span
                                    style="
                                      word-break: break-all !important;
                                      word-wrap: break-word;
                                      color: #bd1c9c;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                    >{{
                                      data.first_name ? data.first_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  "
                                  style="color: #bd1c9c; cursor: pointer">
                                  <span
                                    style="
                                      word-break: break-all !important;
                                      word-wrap: break-word;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.middle_name ? data.middle_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  "
                                  :style="
                                    data.block == 'Y'
                                      ? 'background-color:rgb(254, 254, 204)'
                                      : ''
                                  ">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.last_name ? data.last_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  ">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.native_place_district_name
                                        ? data.native_place_district_name + ","
                                        : "-"
                                    }}
                                  </span>
                                  <br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.native_place_taluka_name
                                        ? data.native_place_taluka_name
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  "
                                  class="">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.district_name
                                        ? data.district_name + ", "
                                        : "-"
                                    }}
                                  </span>
                                  <br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.goan ? data.goan : "-" }}
                                  </span>
                                </td>
                                <td
                                  class=""
                                  style="color: #bd1c9c; cursor: pointer"
                                  v-on:click="
                                    goToUrlV2(
                                      data.id,
                                      '/view-user-detail/' +
                                        data.uuid +
                                        '/SHORT',
                                    )
                                  ">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.working_place_taluka_name
                                        ? data.working_place_taluka_name + ", "
                                        : "-"
                                    }}
                                  </span>
                                  <br />
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.working_place_goan
                                        ? data.working_place_goan
                                        : ""
                                    }}
                                  </span>
                                </td>
                                <td class="">
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.annual_income ||
                                      data.annual_income == 0
                                        ? this.$helperService.kFormatter(
                                            data.annual_income,
                                          )
                                        : ""
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    style="
                                      word-break: break-all !important;
                                      word-wrap: break-word;
                                      color: #bd1c9c;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{ data.education_courses }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    style="color: #bd1c9c; cursor: pointer"
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.dob
                                        ? $helperService.getFormatedDateNew(
                                            data.dob,
                                          )
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td
                                  style="color: #bd1c9c; cursor: pointer"
                                  class=""
                                  :style="
                                    data.membership_end_date == null ||
                                    this.$helperService.CompareDate(
                                      data.membership_end_date,
                                    )
                                      ? 'background-color: rgb(210, 242, 210);'
                                      : 'white'
                                  ">
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    ">
                                    {{
                                      data.height
                                        ? $helperService.getHeight(data.height)
                                        : "-"
                                    }}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="row mx-0 mb-4">
                            <div class="col-lg-12 mt-2 text-center">
                              <div class="page-bottom-pagination text-right">
                                <Pagination
                                  @page-change="pageChange"
                                  @items-per-page-change="itemsPerPageChange"
                                  ref="listPagination" />
                              </div>
                            </div>
                          </div>
                          <ErrorComponent
                            @retry="getList(0)"
                            ref="errorComponent" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TextModal ref="textModal">
        <div class="modal-header">
          <h5 class="modal-title">Select Type</h5>
          <button
            type="button"
            class="close"
            v-on:click="$refs.textModal.closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Form ref="matchForm">
          <div class="modal-body">
            <div class="col-12">
              <div class="form-group">
                <div class="d-flex">
                  <div class="form-check">
                    <input
                      v-on:click="
                        $router.push(
                          '/short-list/' + this.searchObj.uuid + '/' + 'SHORT',
                        )
                      "
                      class="form-check-input"
                      type="radio"
                      name="listType"
                      id="short_list"
                      value="SHORT" />
                    <label class="form-check-label" for="short_list">
                      Short List
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      v-on:click="
                        $router.push(
                          '/broad-list/' + this.searchObj.uuid + '/' + 'BROAD',
                        )
                      "
                      class="form-check-input"
                      type="radio"
                      name="listType"
                      id="broad_list"
                      value="BROAD" />
                    <label class="form-check-label" for="broad_list">
                      Broad List
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
                  <button class="fill-btn" id="save-button">Save</button>
                  <button
                    type="button"
                    class="fil-btn"
                    id="cancel-button"
                    v-on:click="$refs.textModal.closeModal"
                  >
                    Cancel
                  </button>
                </div> -->
        </Form>
      </TextModal>
    </div>
    <DeleteModal @remove="accept($event)" ref="hideModal" />
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
    <DeleteModal @remove="blockUser($event)" ref="blockModal" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import DeleteModal from "@/components/DeleteModal";
import TextModal from "@/components/TextModal";

export default {
  name: "MemberList",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
    TextModal,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Users"),
      type: this.$route.params.type,
      sort_id: "",
      order_by: "",
      sort_by: "",
      loader: true,
      isShow: true,
      currentTab: "ACCEPTED",
      isShowAccessDeniedMessage: false,
      searchObj: {
        uuid: "",
        keyword: "",
        marital_status_id: "",
        type: "MARITAL_STATUS",
        gender: "",
        is_hidden: "",
        membership_plan_id: "",
        is_incomplete: 0,
      },
      count: 0,
      offset: -1,
      list: [],
      marriedStatusList: [],
      planList: [],
    };
  },
  mounted() {
    this.getFilter();
    console.log("object", this.accessObject);
    localStorage.setItem("tab_type", "MEMBER");
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = false;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    if (this.type) {
      this.toggleMenu();
    } else {
      this.toggleMenu();
      this.$helperService.showMenu("false");
    }
    this.getMarriedStatusList("MARITAL_STATUS");
    this.getPlanList();
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab;
      this.searchObj.keyword = "";
    },
    goToUrl(id, url) {
      var obj = {};
      obj.id = "member_" + id;
      this.$shareService.setMapValue("member_lists", obj);
      this.$router.push(url);
    },
    goToUrlV2(id, url) {
      var obj = {};
      obj.id = "member_" + id;
      this.$shareService.setMapValue("member_lists", obj);
      // this.$router.push(url);
      window.open(
        url,
        "mywindow",
        "menubar=1,resizable=1,width=3500,height=1300",
      );
    },

    getFilter() {
      this.searchObj = this.$shareService.getMapValue("member_lists_filter")
        ? this.$shareService.getMapValue("member_lists_filter")
        : {
            uuid: "",
            keyword: "",
            marital_status_id: "",
            type: "MARITAL_STATUS",
            gender: "",
            is_hidden: "",
            membership_plan_id: "",
            is_incomplete: 0,
            offset: 0,
          };
      this.$helperService.sortingPrevent(
        this.searchObj.order_by,
        this.searchObj.sort_id,
      );
      if (!this.searchObj.is_hidden) {
        this.searchObj.is_hidden = "";
      }
      if (!this.searchObj.marital_status_id) {
        this.searchObj.marital_status_id = "";
      }
      if (this.searchObj.offset || this.searchObj.offset == 0) {
        this.$refs.listPagination.setTotalCount(this.searchObj.count, 50);
        this.$refs.listPagination.setCurrentPage(this.searchObj.offset + 1);
        this.getList(this.searchObj.offset);
      } else {
        this.getList(0);
      }
    },
    toggleMenu() {
      this.isShow = !this.isShow;
      // this.searchObj.is_hidden = '';
      // this.searchObj.marital_status_id = '';
      this.searchObj.s = "";
      if (this.isShow == true) {
        this.$helperService.showMenu("true");
      } else {
        this.$helperService.showMenu("false");
      }
    },
    downloadProfile(data) {
      var url = this.$api.getBaseUrl() + "/get/biodata?uuid=" + data.uuid;
      window.open(url);
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getPlanList() {
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.planList = res.list;
        })
        .catch(() => {});
    },
    getMarriedStatusList(type) {
      this.searchObj.type = type;
      this.$api
        .getAPI({
          _action: "/master-data/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.marriedStatusList = res.list;
        })
        .catch(() => {});
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      if (this.sort_id) {
        this.searchObj.sort_id = this.sort_id;
      }

      this.$api
        .getAPI({
          _action: "/member/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.count = res.count;
          this.offset = res.next_offset;
          this.searchObj.count = res.count;
          this.$shareService.setMapValue("member_lists_filter", this.searchObj);
          this.accessObject =
            this.$helperService.getAccessLevel("Manage Users");
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count, 50);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Member List Available");
            this.$refs.errorComponent.updateListLoader(false);
          }

          var shareobj = this.$shareService.getMapValue("member_lists")
            ? this.$shareService.getMapValue("member_lists")
            : null;

          if (shareobj && shareobj.id) {
            setTimeout(() => {
              document.getElementById(shareobj.id).scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }, 100);
          }
          this.$shareService.setMapValue("member_lists", null);
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    showHidePopup(data) {
      this.$refs.hideModal.showModal(
        data.is_hidden == "N" ? "Hide" : "UnHide",
        data.is_hidden == "N"
          ? "Are you sure you want to  hide " + data.registration_no
          : "Are you sure you want to unhide" + data.registration_no,
        data,
      );
    },
    accept(dataObj) {
      var detail = new Proxy(dataObj, {});
      console.log("fgfg", detail.is_hidden);
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
      }
      if (detail.is_hidden == "N") {
        obj.is_hidden = "Y";
      } else {
        obj.is_hidden = "N";
      }
      this.$api
        .putAPI({
          _action: "/hide-user",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.hideModal.closeModal();
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
          this.getFilter(0);
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.sort_id = id;
      this.order_by = obj.order_by;
      this.sort_by = obj.sort_by;
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj = {};
      this.searchObj.keyword = "";
      this.searchObj.gender = "";
      this.searchObj.is_hidden = "";
      this.searchObj.is_membership_subscribed = "";
      this.searchObj.membership_plan_id = "";
      this.searchObj.marital_status_id = "";
      this.searchObj.is_incomplete = 0;
      this.getList(0);
    },
    resetStatusFilter() {
      this.searchObj.marital_status_id = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Members",
        "Are you sure you want to delete " + data.first_name,
        data,
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "DELETED";
      }
      this.$api
        .putAPI({
          _action: "/update-status",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getFilter(0);
            this.$notify({
              type: "success",
              text: "User deleted successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    showMatchPopup(data) {
      this.searchObj.uuid = data.uuid;
      // this.$refs.matchForm.resetForm();
      this.$refs.textModal.showModal();
    },
    showBlockPopup(data) {
      console.log("object", data);
      this.$refs.blockModal.showModal(
        data.status != "BLOCKED" ? " Block Member" : "Unblock Member",
        data.status != "BLOCKED"
          ? "Are you sure you want to  block " + data.first_name
          : "Are you sure you want to unblock " + data.first_name,
        data,

        // "Block Members",
        // "Are you sure you want to {{data.status = BLOCKED ? block : unblock}} " +
        //   data.first_name,
        // data
      );
    },
    blockUser(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        if (dataObj.status == "BLOCKED") {
          obj.status = "ACTIVE";
        } else {
          obj.status = "BLOCKED";
        }
      }

      this.$api
        .putAPI({
          _action: "/update-status",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.blockModal.closeModal();
            this.getFilter(0);
            this.$notify({
              type: "success",
              text: res.status,
            });
          }
        })
        .catch(() => {
          this.$refs.blockModal.removeLoader();
        });
    },
    downloadPdf() {
      var url = this.$api.getBaseUrl() + "/member/list/report";
      window.open(url);
    },
    downloadBlankFormPdf() {
      var url = this.$api.getBaseUrl() + "/blank/biodata";
      window.open(url);
    },
  },
};
</script>
